export default Object.freeze({
  QUERY: 'Incorrect Query Param',
  SECOND_ARG_NULL: 'Second argument cannot be null',
});
